import ApiService from '../api.service';

const TermsResource = {
  current: () => ApiService.get('/v1/terms/current'),
};

export default TermsResource;
